import api from "../axios";

export interface GetEnterpriseEnquiryParams {
    fromdate: string;
    todate: string;
}

export const getEnterpriseEnquiry = (fromdate: string, todate: string) => {
    return api.get(
        `/booking/getEnterpriseEnquiry?fromdate=${fromdate}&todate=${todate}`
    );
};